const CHECK_INTERVAL_MS = 60_000;
const MIN_CHECK_GAP_MS = 30_000;
// Temporary product switch: keep the header notice visible until this is disabled.
const TEMPORARILY_SHOW_UPDATE_NOTICE = false;

let availableBuildId: string | null = TEMPORARILY_SHOW_UPDATE_NOTICE
  ? __APP_BUILD_ID__
  : null;
let dismissedBuildId: string | null = null;
const listeners = new Set<() => void>();

type DeploymentVersion = {
  buildId?: unknown;
};

export function subscribeToDeploymentUpdates(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getAvailableDeploymentBuildId() {
  return availableBuildId;
}

export function dismissDeploymentUpdate() {
  dismissedBuildId = availableBuildId;
  availableBuildId = null;
  listeners.forEach((listener) => listener());
}

export function startDeploymentUpdateCheck() {
  let lastCheckedAt = 0;
  let isChecking = false;

  async function checkForUpdate() {
    if (
      isChecking ||
      document.visibilityState !== "visible" ||
      !navigator.onLine ||
      Date.now() - lastCheckedAt < MIN_CHECK_GAP_MS
    ) {
      return;
    }

    isChecking = true;
    lastCheckedAt = Date.now();

    try {
      const response = await fetch(`/version.json?t=${lastCheckedAt}`, {
        cache: "no-store",
      });
      if (!response.ok) return;

      const version = (await response.json()) as DeploymentVersion;
      if (
        typeof version.buildId !== "string" ||
        version.buildId === __APP_BUILD_ID__ ||
        version.buildId === dismissedBuildId ||
        version.buildId === availableBuildId
      ) {
        return;
      }

      availableBuildId = version.buildId;
      listeners.forEach((listener) => listener());
    } catch {
      // A failed check should not interrupt the page; the next check retries.
    } finally {
      isChecking = false;
    }
  }

  void checkForUpdate();
  window.setInterval(() => void checkForUpdate(), CHECK_INTERVAL_MS);
  window.addEventListener("focus", () => void checkForUpdate());
  window.addEventListener("online", () => void checkForUpdate());
  document.addEventListener("visibilitychange", () => void checkForUpdate());
}
